import React, { useState } from "react";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import LoadableButton from "../../../components/button/LoadableButton";
import { AddUpdateInvoiceTemplateApi } from "../../../api/request/invoice";
import Delete from "../../../assets/Delete";
import Add from "../../../assets/Add";

const TemplateForm = ({ mode, setMode, selectedTemplate, getTemplateList }) => {
  const [form] = Form.useForm();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const initialValues = {
    name: selectedTemplate?.name || "",
    charges: selectedTemplate?.charges || [
      {
        title: "",
        description: "",
        charge: "",
      },
    ],
  };

  const onSubmitTemplate = async (values) => {
    try {
      setIsSubmitLoading(true);
      let data = {};

      const params = {
        ...(mode === "edit" && { invoice_temp_id: selectedTemplate?.id }),
        ...values,
      };

      if (mode === "edit") {
        const res = await AddUpdateInvoiceTemplateApi(params);
        data = res?.data;
      } else {
        const res = await AddUpdateInvoiceTemplateApi(params);
        data = res?.data;
      }

      if (data.status) {
        setIsSubmitLoading(false);
        toast.success(data.message);
        form.resetFields();
        setMode("view");
        getTemplateList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsSubmitLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="font-semibold text-xl mb-4">
        {mode === "edit" ? "Edit Template" : "Create Template"}
      </h2>

      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onSubmitTemplate}
      >
        <Form.Item
          name="name"
          label="Template Name"
          rules={[
            {
              required: true,
              message: "Please enter the template name",
            },
          ]}
        >
          <Input placeholder="Enter template name" size="large" />
        </Form.Item>

        {/* Charges Section */}
        <Form.List name="charges">
          {(fields, { add, remove }) => (
            <div>
              {fields.map(({ key, name, ...restField }) => (
                <div
                  key={key}
                  className="mb-4 p-4 border rounded-lg flex items-end justify-between gap-5"
                >
                  <div className="flex flex-1 gap-5">
                    <Form.Item
                      {...restField}
                      name={[name, "title"]}
                      label="Charge Title"
                      rules={[
                        { required: true, message: "Enter charge title" },
                      ]}
                      className="mb-0 w-1/3"
                    >
                      <Input placeholder="Enter charge title" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "description"]}
                      label="Charge Description"
                      rules={[
                        { required: true, message: "Enter charge description" },
                      ]}
                      className="mb-0 w-1/3"
                    >
                      <Input placeholder="Enter charge description" />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "charge"]}
                      label="Charge Amount"
                      rules={[
                        { required: true, message: "Enter charge amount" },
                      ]}
                      className="mb-0 w-1/3"
                    >
                      <Input
                        type="number"
                        placeholder="Enter charge amount"
                        min={0}
                      />
                    </Form.Item>
                  </div>

                  <button
                    type="button"
                    className="mb-2"
                    onClick={() => remove(name)}
                  >
                    <Delete />
                  </button>
                </div>
              ))}

              <button
                type="button"
                className="bg-primary text-white flex items-center gap-2 px-4 py-2 rounded-lg mt-2"
                onClick={() => add()}
              >
                <Add />
                <span>Add Charge</span>
              </button>
            </div>
          )}
        </Form.List>

        <div className="mt-5 flex gap-3">
          <LoadableButton
            className="bg-secondary text-sm text-white font-medium px-8 py-2 rounded-lg themeHover duration-500"
            type="submit"
            lable="Submit"
            isLoading={isSubmitLoading}
            loadingLable="Submitting Template..."
          />
          <button
            className="flex items-center px-4 py-1.5 font-medium border border-secondary text-secondary rounded-lg"
            onClick={() => setMode("view")}
          >
            Cancel
          </button>
        </div>
      </Form>
    </div>
  );
};

export default TemplateForm;
